import { Check, NotebookPen } from 'lucide-react';
import type { MouseEvent, ReactNode } from 'react';
import { Button } from '../../../components/ui/button.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';

type Props = {
    isLogged: boolean;
    disabled?: boolean;
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
};

export function EventLogButton({ isLogged, disabled, onClick }: Props): ReactNode {
    const { t } = useLocale('events');

    return (
        <div className="w-full flex justify-end">
            <Button
                disabled={disabled}
                variant={isLogged ? 'ghost' : 'secondary'}
                icon={isLogged ? Check : NotebookPen}
                onClick={onClick}
                className={isLogged ? 'text-green-600' : undefined}
            >
                {isLogged ? t('card_log_button_logged') : t('card_log_button')}
            </Button>
        </div>
    );
}
